  <nav class="top-bar">
    <div (click)="backButtonClicked($event)" class="back-link">
      <mat-icon svgIcon="arrow-left"></mat-icon>
      <mat-icon svgIcon="logo-small"></mat-icon>
    </div>
    <div class="product-title"
         [class.product-chooser]="displayProductChooser && isFirstDesignStep"
         (click)="openProductChooser()">
      <span class="name">
        {{ productName }}
      </span>
      @if (displayProductChooser && isFirstDesignStep) {
        <mat-icon svgIcon="caret-down"></mat-icon>
      }
    </div>

    <div class="nav-controls">
      <mat-icon svgIcon="arrow-back"></mat-icon>
      <mat-icon svgIcon="arrow-forward"></mat-icon>
    </div>
  </nav>
  @if (activeToolbox === 'ProductChooserToolbox') {
    <product-chooser-toolbox></product-chooser-toolbox>
  }
